import { BinIcon, PenIcon } from '../../../assets/icons'
import styles from './RowActions.module.scss'

export interface RowActionsProps {
  onEdit?: () => void
  onDelete?: () => void
  editLabel?: string
  deleteLabel?: string
}

export default function RowActions({
  onEdit,
  onDelete,
  editLabel = 'Modifier',
  deleteLabel = 'Supprimer',
}: RowActionsProps) {
  return (
    <div className={styles.actions}>
      {onEdit && (
        <button
          type="button"
          className={styles.actionButton}
          aria-label={editLabel}
          title={editLabel}
          onClick={onEdit}
        >
          <div className={styles.iconWrapper}>
            <PenIcon size={16} />
          </div>
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          className={`${styles.actionButton} ${styles['actionButton--danger']}`}
          aria-label={deleteLabel}
          title={deleteLabel}
          onClick={onDelete}
        >
          <div className={styles.iconWrapper}>
            <BinIcon size={16} />
          </div>
        </button>
      )}
    </div>
  )
}
